module.exports = __webpack_public_path__ + "static/1-dc11ba68a679b9144344455f1bc8bc63.jpg";